export const SIGNING_DOCUMENT_TYPES = ["ACH_FORM", "CC_AUTH_FORM"];
export const SIGNING_DOCUMENT_STATUSES = ["NOT_STARTED", "SIGNED"];
export const SIGNING_DOCUMENT_DETAILS = {
    ACH_FORM: {
        label: "ACH Form",
        description: "Share the bank account we'll use to send your platform refunds.",
        route: "/my-agent/documents/ach-form",
    },
    CC_AUTH_FORM: {
        label: "Card Authorization",
        description: "Authorize recurring weekly funding charges to your card on file.",
        route: "/my-agent/documents/cc-auth-form",
    },
};
export function isSigningDocumentType(value) {
    return typeof value === "string" && SIGNING_DOCUMENT_TYPES.includes(value);
}
export function signingDocumentTypeForRouteSegment(segment) {
    if (segment === "ach-form")
        return "ACH_FORM";
    if (segment === "cc-auth-form")
        return "CC_AUTH_FORM";
    return null;
}
